import React from 'react'
import { Table } from 'semantic-ui-react'
import { useTable, useSortBy } from 'react-table'


function AppraisalTable({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const { getTableProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data,
    },
    useSortBy
  )

  // Render the UI for your table
  return (
    <Table {...getTableProps()} striped>
      <Table.Header>
        {headerGroups.map(headerGroup => (
          <Table.Row {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <Table.HeaderCell {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
                <span>{column.isSorted? (column.isSortedDesc?' v':' ^'):''}</span>
              </Table.HeaderCell>
            ))}
          </Table.Row>
        ))}
      </Table.Header>
      <Table.Body>
        {rows.map(
          (row, i) =>
            prepareRow(row) || (
              <Table.Row {...row.getRowProps()}>
                {row.cells.map(cell => (
                  <Table.Cell {...cell.getCellProps()}>{cell.render('Cell')}</Table.Cell>
                ))}
              </Table.Row>
            )
        )}
      </Table.Body>
    </Table>
  )
}

export default AppraisalTable
